// extracted by mini-css-extract-plugin
export default {"footer-container":"Footer_footer-container__eZnXC","footer-title":"Footer_footer-title__vkflM","footer-copyright":"Footer_footer-copyright__MvEE3"};